// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_ovM","cls2":"ReferenceCard-cls2_YfM ReferenceCard-cls1_ovM"};